<template >
  <div class="checkout-tile" v-if="method">
    <div class="input-type-radio">
      <input
        @click="setSelected()"
        type="radio"
        :id="method.id"
        name="delivery-method"
        :value="method.id"
        :disabled="!method.enabled"
        :checked="method.selected"
      />
      <label :for="method.id">
        <span class="tile-type">{{ method.methodLabel }}</span>
        <span class="body-text">{{ method.description }}</span>
        <span class="method-price">{{ selectedOption && selectedOption.price ? selectedOption.price : method.price }}</span>
      </label>
    </div>
  </div>
</template>
<script src="./delivery-method-tile.js"/>
